import { render, staticRenderFns } from "./defaultStatus.vue?vue&type=template&id=6c421ba5&scoped=true&"
import script from "./defaultStatus.vue?vue&type=script&lang=js&"
export * from "./defaultStatus.vue?vue&type=script&lang=js&"
import style0 from "./defaultStatus.vue?vue&type=style&index=0&id=6c421ba5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c421ba5",
  null
  
)

export default component.exports